import { Fragment } from "react";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";

const Mission = () => {
  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="mision-hero">
        <div className="container">
          <div className="mision-hero-content">
            <h1 className="mision-hero-title">Misión, Visión y Valores</h1>
            <p className="mision-hero-subtitle">
              Lo que nos define como empresa
            </p>
          </div>
        </div>
      </div>

      {/* Sección Principal */}
      <div className="mision-section">
        <div className="container">
          {/* Misión y Visión */}
          <div className="mision-cards">
            {/* Misión */}
            <div className="mision-card">
              <div className="mision-card-header">
                <div className="mision-card-icon">
                  <i className="fa-solid fa-bolt"></i>
                </div>
                <h2 className="mision-card-title">Misión</h2>
              </div>
              <p className="mision-card-text">
                Ser Líder de Autopartes de Suspensión, a través de ofrecer{" "}
                <strong>Calidad</strong>, <strong>Existencia</strong> y{" "}
                <strong>Rapidez</strong>.
              </p>
            </div>

            {/* Visión */}
            <div className="mision-card">
              <div className="mision-card-header">
                <div className="mision-card-icon">
                  <i className="fa-solid fa-eye"></i>
                </div>
                <h2 className="mision-card-title">Visión</h2>
              </div>
              <p className="mision-card-text">
                Contamos con Políticas, Procesos Definidos y Automatizados, para
                llegar a ser una empresa autoadministrada. Personal Capacitado
                en sus áreas, en conocimientos del producto, habilidades y
                actitudes, con enfoque del{" "}
                <strong>Servicio al Cliente</strong>.
              </p>
            </div>
          </div>

          {/* Valores */}
          <div className="mision-valores">
            <div className="mision-valores-header">
              <div className="mision-card-icon">
                <i className="fa-solid fa-heart"></i>
              </div>
              <h2 className="mision-card-title">Valores</h2>
            </div>

            <div className="mision-valores-grid">
              {/* Responsabilidad */}
              <div className="mision-valor-item">
                <div className="mision-valor-icon">
                  <i className="fa-solid fa-shield-halved"></i>
                </div>
                <h3 className="mision-valor-title">Responsabilidad</h3>
                <p className="mision-valor-text">
                  Cumplimos con nuestros compromisos y asumimos las
                  consecuencias de nuestras acciones.
                </p>
              </div>

              {/* Honestidad */}
              <div className="mision-valor-item">
                <div className="mision-valor-icon">
                  <i className="fa-solid fa-handshake"></i>
                </div>
                <h3 className="mision-valor-title">Honestidad</h3>
                <p className="mision-valor-text">
                  Actuamos con transparencia e integridad en todas nuestras
                  relaciones comerciales.
                </p>
              </div>

              {/* Lealtad */}
              <div className="mision-valor-item">
                <div className="mision-valor-icon">
                  <i className="fa-solid fa-users"></i>
                </div>
                <h3 className="mision-valor-title">Lealtad</h3>
                <p className="mision-valor-text">
                  Construimos relaciones duraderas basadas en la confianza con
                  clientes y colaboradores.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default Mission;
